import { Link } from 'react-router-dom'
import { BookOpen, CheckCircle2, Clock3, Store, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'

export default function DocumentationIntro() {
  return (
    <section className='relative overflow-hidden border-b'>
      <div className='absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_-10%,hsl(var(--primary)/.14),transparent_60%)]' />

      <div className='relative mx-auto max-w-7xl px-4 py-16 md:py-20'>
        <div className='grid gap-8 lg:grid-cols-[1.2fr_420px] lg:items-center'>
          <div className='space-y-5'>
            <Badge
              variant='secondary'
              className='inline-flex items-center gap-2'
            >
              <BookOpen className='h-3.5 w-3.5' />
              Guide utilisateur
            </Badge>

            <div className='space-y-3'>
              <h1 className='text-4xl font-extrabold tracking-tight md:text-5xl'>
                Documentation MOGESAPP
              </h1>

              <p className='max-w-2xl text-base text-muted-foreground md:text-lg'>
                Comprenez les modules, démarrez dans le bon ordre et utilisez
                MOGESAPP plus efficacement au quotidien.
              </p>
            </div>

            <div className='flex flex-wrap items-center gap-3'>
              <Link to='/register?redirect=/dashboard'>
                <Button size='lg' className='font-semibold'>
                  Commencer gratuitement
                  <ArrowRight className='ml-2 h-4 w-4' />
                </Button>
              </Link>

              <Link to='/pricing'>
                <Button size='lg' variant='outline'>
                  Voir les tarifs
                </Button>
              </Link>
            </div>

            <div className='flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground'>
              <span className='inline-flex items-center gap-2'>
                <CheckCircle2 className='h-4 w-4 text-primary' />
                Guide simple et concret
              </span>
              <span className='inline-flex items-center gap-2'>
                <Clock3 className='h-4 w-4 text-primary' />
                Prise en main rapide
              </span>
              <span className='inline-flex items-center gap-2'>
                <Store className='h-4 w-4 text-primary' />
                Pensé pour les commerces
              </span>
            </div>
          </div>

          <Card className='rounded-2xl border bg-background/90 p-6 shadow-sm'>
            <div className='space-y-4'>
              <div>
                <div className='text-sm font-semibold text-foreground'>
                  Cette page va vous aider à :
                </div>
                <p className='mt-1 text-sm text-muted-foreground'>
                  comprendre ce que fait l’application, savoir par où commencer
                  et éviter les erreurs fréquentes.
                </p>
              </div>

              <div className='grid gap-3'>
                <div className='rounded-xl border p-4'>
                  <div className='font-medium'>Idéal pour</div>
                  <div className='mt-1 text-sm text-muted-foreground'>
                    boutiques, supérettes, magasins, commerces de détail,
                    activités avec stock et encaissements.
                  </div>
                </div>

                <div className='rounded-xl border p-4'>
                  <div className='font-medium'>Ce que vous allez trouver</div>
                  <div className='mt-1 text-sm text-muted-foreground'>
                    clients, factures, paiements, stock, dépenses, relances et
                    bonnes pratiques d’utilisation.
                  </div>
                </div>

                <div className='rounded-xl border p-4'>
                  <div className='font-medium'>Conseil</div>
                  <div className='mt-1 text-sm text-muted-foreground'>
                    commencez par la mise en place de vos produits, de votre
                    stock et de vos clients avant d’activer les automatismes.
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  )
}
